/* eslint-disable */
import PropTypes from 'prop-types';

const TrucksExpandableSectionPropTypes = {
  /**
   * The current order
   */
  currentOrder: PropTypes.any,

  /**
   * The currentDeliveryDetails
   */
  currentDeliveryDetails: PropTypes.any,
};

export default TrucksExpandableSectionPropTypes;
